'use strict';

// Search
var search = {
	$this: $('#search'),
	scrollTop: 0,
	open: function open(e) {
		e.preventDefault();
		if (!search.$this.hasClass('active')) {
			search.scrollTop = $(window).scrollTop();
			$('#container').css({ 'position': 'fixed', 'margin-top': -Math.abs(search.scrollTop) });
			$('body').addClass('fixed');
			search.$this.show();
			setTimeout(function () {
				search.$this.addClass('active').find('.input input[type="text"]').focus();
				$('body').icons.init('.svg-icon', $('#search'));
			}, 10);
			$('#search-overlay').show();
			setTimeout(function () {
				$('#search-overlay').addClass('show');
			}, 10);
		}
	},
	close: function close(e) {
		if (search.$this.hasClass('active')) {
			e.preventDefault();
			search.$this.removeClass('active');
			$('#search-overlay').removeClass('show');
			setTimeout(function () {
				search.$this.hide();
				$('#search-overlay').hide();
				$('body').removeClass('fixed');
				$('#container').removeAttr('style');
				$('body, html').scrollTop(search.scrollTop);
			}, 500);
		}
	},
	check: function check(e, submit) {
		var val = $('#search input[type="text"]').val();
		$('#search .length_test').html(val);
		var width = $('#search .length_test').outerWidth(true);
		$('#search .stroke .inner').css({ 'width': width });
	},
	init: function init() {
		$('.header .btn-search').on('click', function (e) {
			search.open(e);
		});

		$('#search .search-close').on('click', function (e) {
			search.close(e);
		});

		$('#search').on('click', function (e) {
			if (!e.target.classList.contains('search-ex')) {
				search.close(e);
			}
		});

		$('#search .input input[type="text"]').keypress(function (e) {
			search.check(e, false);
		});

		$('#search .input input[type="text"]').keyup(function (e) {
			search.check(e, true);
		});
	}
};